import { render, staticRenderFns } from "./SalesItemPartList.vue?vue&type=template&id=038c8452&"
import script from "./SalesItemPartList.vue?vue&type=script&lang=js&"
export * from "./SalesItemPartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports